<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/ptPlannerNew')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateaddData('plannerAdd')" data-vv-scope="plannerAdd">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="status_planner" v-validate="'required'" v-model="addData.pt_planner_activity_id" class="form-control">
                    <option value="null">Please select</option>
                    <option v-for="item in plannerActivity" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('plannerAdd.status_planner') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" @change="addData.pt_planner_activity_id == 28 ? changeBranch('pt') : changeBranch()" v-model="addData.branch_id" class="form-control">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-20" v-if="ifPlannerMember(addData.pt_planner_activity_id)">
                <b-col sm="2">
                  <label>Member</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select @searchchange="searchMember" autocomplete="false" @input="changeMemberType('member')" :options="optionsMember" class="border-bottom" name="member_id" v-model="addData.member_id"></model-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="ifPlannerMember(addData.pt_planner_activity_id)">
                <b-col sm="2">
                  <label>Leads</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" @input="changeMemberType('leads')" :options="optionsLeads" class="border-bottom" name="member_id" v-model="addData.member_id"></model-select>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20" v-if="addData.pt_planner_activity_id == 28">
                <b-col sm="2">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select :options="dataPT" class="border-bottom" name="member_id" v-model="addData.pt_id"></model-select>
                  </div>
                </b-col>
              </b-row>

              <div class="text-right">
                <button :disabled="isViewOnly" type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { ModelSelect } from 'vue-search-select'
import Mixin from '../../mixins/memberMixin'
export default {
  name: 'addDataNew',
  components: {
    ModelSelect
  },
  mixins:[Mixin],
  data: function () {
    return {
      loadingActive: false,
      isViewOnly: false,
      listMember: [],
      dataBranch: [],
      // optionsMember: [],
      // optionsLeads: [],
      dataActivity: [],
      plannerActivity: [],
      plannerActivity2: [],
      dataPT:[],
      optionsMember: [
        { value: 0, text: 'Please select' }
      ],
      optionsLeads: [
        { value: 0, text: 'Please select' }
      ],
      addData: {
        branch_id: null,
        personal_trainer_id: '',
        member_id: 0,
        pt_planner_time_id: 0,
        date: '',
        pt_planner_activity_id: null,
        member_type: null,
        pt_id:''
      },
    }
  },
  methods: {
    changeMemberType(ev) {
      console.log(ev)
      this.addData.member_type = ev
    },
    ifPlannerMember (event) {
      if (event === 1 || event === 2 || event === 3 || event === 27 || event === 4 || event === 5 || event === 6 || event === 22 || event === 23) {
        return true
      } else {
        return false
      }
    },
    validateaddData (scope) {
      // validate branch id when is null
      if (this.addData.branch_id === null) {
        this.$toast.success('please select branch!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        return false
      }


      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Save now!',
        cancelButtonText: 'No, Cancel!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((confirm) => {
        if(confirm.value) {
          this.$validator.validateAll(scope).then((result) => {
            if(result) {
              this.loadingActive = true

              // console.log('All Data', this.addData)
              axios.post('crm/v1/pt_planner/', this.addData).then(response => {
                // console.log('test', response)
                this.loadingActive = false
                this.$router.push('/ptPlannerNew' + '?pt_id=' + this.$route.query.pt_id + '&branch_id=' + this.$route.query.branch_id)
                this.$toast.success('data saved successfully!', 'Success', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
              }).catch(error => {
                this.loadingActive = false
                const errMsg = error.response.data
                this.$toast.success(errMsg.error, 'Error', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff',
                  timeout: 5000
                })
              })
            } else {
              this.$toast.success('please fill in required fields!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$swal('Cancelled', '', 'info')
        }
      })

    },
    openPage (event) {
      // this.$router.push(event)
      this.$router.push('/ptPlannerNew' + '?pt_id=' + this.$route.query.pt_id + '&branch_id=' + this.$route.query.branch_id)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    changeBranch(type = 'member') {
      if (type == 'pt') {
        this.getPT()
      } else {
        this.getMember()
      }
    },
    getPT() {
      this.pt_id = ''
      this.dataPT = [{
        value:'',
        text:'All PT'
      }]
      axios
        .get("fitness/v1/personal_training?branch_id=" + this.addData.branch_id)
        .then((response) => {
          let dataPT = response.data.data.rows.map((x) => {
            let data = {...x}
            data.value = data.id
            data.text = data.name
            return data
          });
          this.dataPT = [...this.dataPT,...dataPT]
          // console.log('test', response.data.data.rows)
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    fetchData() {
      // get Branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
      axios.get('crm/v1/pt_planner_activity/custom?sorting=id&sorting_type=asc').then(response => {
        this.dataActivity = response.data.data.rows
        var data1 = this.dataActivity
        // if(Auth.Session.get().paradigm_role == 4 || Auth.Session.get().paradigm_role == 13) {
        //   this.plannerActivity = data1.filter(item => item.id == 2)
        // } else if (Auth.Session.get().paradigm_role == 3) { // role sales
        //   this.plannerActivity = data1.filter(item => item.id == 2 && item.id == 17)
        // } else if (Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 8) { // role cs
        //   this.plannerActivity = data1.filter(item => item.id == 2 && item.id == 6 && item.id == 17)
        // } else {
        //   this.plannerActivity = data1
        // }

        // login agung & arif
        if (Auth.Session.get().paradigm_id == 1071806 || Auth.Session.get().paradigm_id == 15101853) {
          this.plannerActivity = data1
        } else  {
          if(Auth.Session.get().paradigm_role == 4 || Auth.Session.get().paradigm_role == 13) {
            this.plannerActivity = data1.filter(item => item.id == 2 || item.id == 27)
          } else if (Auth.Session.get().paradigm_role == 3) { // role sales
            if (Auth.Session.get().paradigm_id == 1061843) { // mustikasari@paradigmfitnessindonesia.com
              // this.plannerActivity = data1.filter(item => item.id == 2 || item.id == 17 || item.id == 6)
               this.plannerActivity = data1.filter(item => item.id != 28)
            } else {
              this.plannerActivity = data1.filter(item => item.id == 2 || item.id == 17 || item.id == 27)
            }
          } else if (Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 8 || Auth.Session.get().paradigm_role == 6) { // role cs
            this.plannerActivity = data1.filter(item => item.id == 2 || item.id == 6 || item.id == 17 || item.id == 27)
          } else {
            // Remove for Login PT
            if (Auth.Session.get().paradigm_role == 7) {
            //  data1 = data1.splice(5, 1)
              data1 = data1.filter(item => item.id == 29 || item.id == 27 || item.id == 7 || item.id == 8 || item.id == 9 || item.id == 11 || item.id == 10 || item.id == 13 || item.id == 14 || item.id == 15 || item.id == 16)
            }
            if (Auth.Session.get().paradigm_role == 31) {
            //  data1 = data1.splice(5, 1)
              data1 = data1.filter(item => item.id == 27 || item.id == 28 || item.id == 30 || item.id == 29 || item.id == 7 || item.id == 8 || item.id == 9 || item.id == 11 || item.id == 10 || item.id == 13 || item.id == 14 || item.id == 15 || item.id == 16)
            }

            this.plannerActivity = data1
          }
        }
      }).catch(error => {
        console.log('error', error)
      })
      this.getMember()
      this.getPT()
      // List leads
      axios.get('crm/v1/leads/pt-planner-leads').then(response => {
        let listLeads = response.data.data.rows
        for (var i = 0; i < listLeads.length; i++) {
          let memberLeads
          if(listLeads[i].branch_id) {
            memberLeads = '(' + listLeads[i].id + ') ' + listLeads[i].first_name + ' ' + listLeads[i].last_name
          } else {
            memberLeads = '(' + listLeads[i].id + ') ' + listLeads[i].first_name + ' ' + listLeads[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: this.listMember[i].first_name + ' ' + this.listMember[i].last_name})
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: listLeads[i].id, text: memberLeads})
          this.optionsLeads.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })

    }
  },
  created () {
    const data = {
      planner_time: this.$route.query.planner_time,
      pt_id: this.$route.query.pt_id,
      branch_id: this.$route.query.branch_id,
      date: this.$route.query.date,
    }
    // console.log(this.addData)
    localStorage.setItem('ptPlannerAddSession', JSON.stringify(data))

    this.addData.pt_planner_time_id = this.$route.query.planner_time
    this.addData.date = this.$route.query.date
    this.addData.branch_id = this.$route.query.branch_id
    if(Auth.Session.get().paradigm_role == 3 || Auth.Session.get().paradigm_role == 4 || Auth.Session.get().paradigm_role == 13 || Auth.Session.get().paradigm_role == 17 || Auth.Session.get().paradigm_role == 6) {
      this.addData.personal_trainer_id = this.$route.query.pt_id
    } else {
      // this.addData.personal_trainer_id = Auth.Session.get().paradigm_id
      this.addData.personal_trainer_id = this.$route.query.pt_id
    }
    this.fetchData()

    const roleMapping = Auth.Session.get().paradigm_role_mapping_id
    const roleId = Auth.Session.get().paradigm_role
    if (roleMapping.includes(17)) {
      this.isViewOnly = false
    } else if (Number(roleId) == 33) {
      this.isViewOnly = true
    }
  }
}
</script>

<style>
</style>
